import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Text from '../../../Text'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'

// Reproduces the former StepImage styled block: base class + $align grid-column
// + (no $src) dotted-placeholder class, with the background image supplied inline.
const stepImageClass = (align, hasSrc) => {
  const classes = [styles.stepImage]
  if (!hasSrc) {
    classes.push(styles.stepImageEmpty)
  }
  if (align === 'left') {
    classes.push(styles.stepImageLeft)
  }
  if (align === 'right') {
    classes.push(styles.stepImageRight)
  }
  return classes.join(' ')
}

function GetFasterHowItWorks({
  eyebrow,
  title,
  subtitle,
  steps = []
}) {
  const formatStepNumber = (num) => {
    return num.toString().padStart(2, '0')
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          {eyebrow && <Text type="heading-8" color={$textTertiary.dark}>{eyebrow}</Text>}
          {title && (
            <h2 className={styles.title}>
              <SimpleBlockContent blocks={title} />
            </h2>
          )}
          {subtitle && <div className={styles.subtitle}><Text type="regular" color={$textTertiary.dark}>{subtitle}</Text></div>}
        </div>

        <div className={styles.stepsContainer}>
          {steps.map((step, index) => {
            const isEven = index % 2 === 0
            const isFirst = index === 0
            const isLast = index === steps.length - 1
            // task #67: step.image is now a ResolvedImage descriptor; use .src for CSS background
            const imageSrc = step.image?.src || null

            return (
              <div className={styles.step} key={index}>
                <div className={styles.mobileStepNumber}>
                  <Text type="heading-5" color={$textPrimary.dark}>{formatStepNumber(index + 1)}</Text>
                </div>
                {isEven ? (
                  <>
                    <div className={`${styles.stepContent} ${styles.stepContentLeft}`}>
                      <h3 className={styles.stepTitle}><Text type="heading-5" color={$textPrimary.dark}>{step.title}</Text></h3>
                      <div className={styles.stepDescription}><Text type="regular" color={$textTertiary.dark}>{step.description}</Text></div>
                    </div>
                    <div className={styles.stepNumberWrapper}>
                      <div className={styles.stepDash}>
                        {isFirst ? (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-top.svg" alt="" width="1" height="160" />
                        ) : (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-dash.svg" alt="" width="1" height="160" />
                        )}
                      </div>
                      <div className={styles.stepNumberBox}><Text type="heading-1" color={$textPrimary.dark}>{formatStepNumber(index + 1)}</Text></div>
                      <div className={styles.stepDash}>
                        {isLast ? (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-bottom.svg" alt="" width="1" height="160" />
                        ) : (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-dash.svg" alt="" width="1" height="160" />
                        )}
                      </div>
                    </div>
                    <div className={stepImageClass('right', !!imageSrc)} style={imageSrc ? { backgroundImage: `url(${imageSrc})` } : undefined} />
                  </>
                ) : (
                  <>
                    <div className={stepImageClass('left', !!imageSrc)} style={imageSrc ? { backgroundImage: `url(${imageSrc})` } : undefined} />
                    <div className={styles.stepNumberWrapper}>
                      <div className={styles.stepDash}>
                        {isFirst ? (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-top.svg" alt="" width="1" height="160" />
                        ) : (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-dash.svg" alt="" width="1" height="160" />
                        )}
                      </div>
                      <div className={styles.stepNumberBox}><Text type="heading-1" color={$textPrimary.dark}>{formatStepNumber(index + 1)}</Text></div>
                      <div className={styles.stepDash}>
                        {isLast ? (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-bottom.svg" alt="" width="1" height="160" />
                        ) : (
                          // eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public timeline connector SVG (Next /public), hand-sized 1x160; not resolver-managed content media
                          <img src="/images/get-faster/timeline-dash.svg" alt="" width="1" height="160" />
                        )}
                      </div>
                    </div>
                    <div className={`${styles.stepContent} ${styles.stepContentRight}`}>
                      <h3 className={styles.stepTitle}><Text type="heading-5" color={$textPrimary.dark}>{step.title}</Text></h3>
                      <div className={styles.stepDescription}><Text type="regular" color={$textTertiary.dark}>{step.description}</Text></div>
                    </div>
                  </>
                )}
                <div className={styles.mobileStepImage} />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default GetFasterHowItWorks
